const UNKNOWN_VERSION_NAMES = new Set(['', '未知', '历史版本']);
const DEFAULT_VERSION_ROW_LIMIT = 50;

function isHistoricalVersion(version) {
    return UNKNOWN_VERSION_NAMES.has(String(version || '').trim());
}

function versionSortValue(version) {
    if (isHistoricalVersion(version)) {
        return Number.NEGATIVE_INFINITY;
    }

    const normalized = String(version || '').trim();
    const matched = normalized.match(/V(\d+)(?:\.(\d+))?/i);
    if (!matched) {
        return Number.NEGATIVE_INFINITY + 1;
    }

    const major = Number(matched[1] || 0);
    const minor = Number(matched[2] || 0);
    return major * 1000 + minor;
}

function sortByVersionDesc(left, right) {
    const leftHistorical = isHistoricalVersion(left.rawVersion);
    const rightHistorical = isHistoricalVersion(right.rawVersion);
    if (leftHistorical !== rightHistorical) {
        return leftHistorical ? 1 : -1;
    }

    const versionDiff =
        versionSortValue(right.rawVersion) - versionSortValue(left.rawVersion);
    if (versionDiff !== 0) {
        return versionDiff;
    }

    return left.displayVersion.localeCompare(right.displayVersion);
}

export function displayVersionName(version) {
    const normalized = String(version || '').trim();
    return isHistoricalVersion(normalized) ? '历史版本' : normalized;
}

export function normalizeVersionStat(item) {
    const rawVersion = String(item?.version || '').trim();
    return {
        version: rawVersion,
        rawVersion,
        displayVersion: displayVersionName(rawVersion),
        count: Number(item?.count || 0)
    };
}

export function splitVersionStatsByMazdaPrefix(stats) {
    const normalized = Array.isArray(stats)
        ? stats.map(normalizeVersionStat)
        : [];

    return {
        left: normalized
            .filter((item) => !item.rawVersion.startsWith('MAZDA'))
            .sort(sortByVersionDesc),
        right: normalized
            .filter((item) => item.rawVersion.startsWith('MAZDA'))
            .sort(sortByVersionDesc)
    };
}

function rowBanTime(row) {
    return String(row?.ban_time || row?.banTime || '');
}

function normalizeBlackRow(row, serverName) {
    return {
        sn: row?.sn || '',
        ban_reason: row?.ban_reason || row?.banReason || '',
        version: row?.version || '',
        ban_time: rowBanTime(row),
        server: serverName
    };
}

function versionKeys(version) {
    const normalized = String(version || '').trim();
    if (isHistoricalVersion(normalized)) {
        return ['', '未知', '历史版本'];
    }
    return [normalized];
}

export function northAmericaRowsFromStats(stats, serverName) {
    const rows = stats?.northAmericaList;
    if (!Array.isArray(rows)) {
        return [];
    }

    return rows.map((row) => normalizeBlackRow(row, serverName));
}

export function versionRowsFromStats(
    stats,
    version,
    serverName,
    limit = DEFAULT_VERSION_ROW_LIMIT
) {
    const lists = stats?.versionLists;
    if (!lists || typeof lists !== 'object') {
        return [];
    }

    const rows = versionKeys(version)
        .map((key) => lists[key])
        .find((value) => Array.isArray(value)) || [];

    return rows
        .map((row) => normalizeBlackRow(row, serverName))
        .sort((left, right) => right.ban_time.localeCompare(left.ban_time))
        .slice(0, limit);
}
